const getLanguage = () => {
    const language = typeof window !== `undefined` ?
        localStorage.getItem("site_Language") || window.navigator.language.slice(0, 2) || "en" :
        "en";
    return language
}

export default getLanguage;